<section class="statusUpdatePopup">
  <div class="modal-dialog m-0" style="max-width: 100%">
    <div class="modal-content">
      <app-modal-header-common
        [title]="actionLabel + ' ' + moduleLabel"
        [dialogRef]="dialogRef"
      >
      </app-modal-header-common>

      <div class="modal-body" style="padding-bottom: 0px">
        <p
          [innerHTML]="confirmationWarning"
          style="text-align: center"
        ></p>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-end gap-2">
          <button mat-button (click)="closeDialog()">
            {{ buttonsText.cancel_btn }}
          </button>

          <button mat-flat-button color="primary" (click)="confirm()">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</section>